module.exports = __webpack_public_path__ + "static/media/Adobe_Photoshop.8ca8f89d.svg";